import { TalisEngageSettingsTier } from '®app/settings/talis-engage/talis-engage-settings.state';

import { ListReviewAndPublishMode } from './list-review-and-publish-mode';

export interface FeatureFlags {
  isAddFromWorksEnabled?: boolean;
  isDigitisationWorkflowEnabled?: boolean;
  isMisDashboardEnabled?: boolean;
  isMusicScoresDigitisationEnabled?: boolean;
  isReportBrokenLinkEnabled?: boolean;
  reviewWorkflow?: ListReviewAndPublishMode;
  discoverySystemId?: string | null;
  isAutofillProfileEnabled?: boolean;
  isCourseReserveWorkflowEnabled?: boolean;
  isCourseFlowTenancy?: boolean;
  isPersonaPkceLoginEnabled?: boolean;
  requiredItemImportances?: RequiredItemImportanceLevels | null;
  isUnstableResourceTypesEnabled?: boolean;
  fileUploadToReadingListCustomerTier?: TalisEngageSettingsTier;
}

export enum RequiredItemImportanceLevels {
  OFF = 'off',
  WARN = 'warn',
  ENFORCE = 'enforce',
}
